<div class="fieldset-group">
  <ng-content></ng-content>
</div>
